export default __webpack_public_path__ + "static/media/linux.bdf4a30d.png";